import { getTheme } from './ac'

export function handleGetTheme(theme) {
	return (dispatch) => {
		dispatch(getTheme(theme))
	}
}